<template>
  <div>
    <!-- TODO: Implement exact word match using side-bar search -->
    <side-bar 
      title="Content lists" 
      icon="view_list" 
      search 
      v-model="search"
    >
      <!-- Header bar -->
      <template v-slot:buttons>
        <k-btn size="s" icon no-margin  
          @click.stop="open_add" 
          v-if="$is_privilege(['root', 'developer', 'admin', 'group_admin', 'device_admin'])"
          icon-name="add"
        />
      </template>

      <!-- Body -->
      <div>
        <!-- Pinned lists -->
        <div v-show="pinned_lists.length > 0">
          <k-btn icon no-margin size="s"
            @click="show_pinned_list = !show_pinned_list"
            :icon-name="show_pinned_list ? 'expand_more' : 'chevron_right'"
          />
          <span>Pinned Lists</span>

          <k-list
            bordered 
            class="ks-pinned-list"
            :items="pinned_lists" 
            v-show="show_pinned_list" 
            @click="(item) => {open_list(item.id)}"
          >
            <template #default="{ item }">
                {{ item.id }}
                {{ item.name }}
            </template>

            <template #subtitle="{ item }">
              {{ get_path_string(item.id) }}
            </template>

            <template #right="{ item }">
              <k-btn size="s" icon active no-margin class="ma-0 pa-0"
                @click="unpin(item.id)"
                icon-name="push_pin"
              />
            </template>
          </k-list>
          <k-divider/>
        </div>

        <!-- Tree -->
        <tree activatable :search="search" :id="id"/>

      </div>
    </side-bar>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from '../BottomSheet'
import SideBar from '@/components/SideBar.vue'
import ContentModel from '@/models/content.js'
import Tree from './Tree.vue'
import Vue from 'vue'

export default {
  props:{
    id: String
  },
  components: {
    BottomSheet,
    SideBar,
    Tree
  },
  data () {
    return {
      search: "",
      show_pinned_list: true,
    }
  },
  computed: {
    pinned_lists () {
      if(_.isEmpty(this.cms_lists)) return [];
      let ids = _.get(this.$store.state.account, 'meta.cms_pinned_lists', []);
      let lists = [];
      ids.forEach((id) => {
        if(this.cms_lists[id]) lists.push(this.cms_lists[id]);
      });
      return lists;
    },
    cms_lists () {
      if(this.$store.getters.is_privilege(["developer"])) {
        return this.$store.state.cms_lists;
      }
      return this.$store.state.cms_lists_no_sys;
    }
  },
  mounted () {
    this.$store.dispatch("get_profile");
  },
  methods: {
    open_list (id) {
      this.$router.push("/content/list/"+id);
    },
    open_add () {
      this.$router.push("/content/list/"+this.id+"/new");
    },
    get_path_string (id) {
      let path = ContentModel.get_path(id);
      let path_str = "";
      path.forEach((id) => path_str = " / " + this.cms_lists[id].name + path_str);
      return path_str;
    },
    unpin (id) {
      if (!this.$store.state.account) return;
      let acc = _.cloneDeep(this.$store.state.account);
      acc.meta.cms_pinned_lists = _.xor(acc.meta.cms_pinned_lists, [id]);
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>

<style scoped>
.ks-pinned-list {
  padding-left: 0px;
  height: auto;
  margin-bottom: 10px;
}
.ks-pinned-list-content {
  display: flex;
}
</style>
